/* global ReactSpringserveComponent */

angular.module('vastdesk').component('bulkNameChangeModal', {
  bindings: {
    type: '@',
    targetTableId: '@',
  },
  template: require('../templates/bulkNameChangeModal.html'),
  controllerAs: '$bulkNameChangeModalCtrl',
  controller: ['$scope', '$rootScope', function ($scope, $rootScope) {
    // FIXME: a lot of this can be consolidated with code from bulkBudgetChangeModal and bulkFCapChangeModal

    const self = this;

    this.rootId = `component-root-angular-ModalBulkNameChange-${Math.floor(Math.random() * 2**52)}`;

    this.open = false;
    this.selectedIds = [];
    this.unregisterWatcher = null;

    this.handleBulkNameChangeModalOpenChange = (open) => {
      self.open = open;
      $scope.$apply();
    };

    this.handleBulkNameChangeSubmitted = () => {
      $scope.$apply();
      location.reload();
    };

    this.renderReactComponent = () => {
      return window.reactComponentScriptLoaded.promise.then(() => {
        ReactSpringserveComponent.renderComponent({
          componentName: 'ModalBulkNameChange',
          rootId: self.rootId,
          componentProps: {
            open: self.open,
            onOpenChange: self.handleBulkNameChangeModalOpenChange,
            onBulkNameChangeSubmitted: self.handleBulkNameChangeSubmitted,
            type: self.type,
            selectedIds: self.selectedIds,
          },
        });
      });
    };

    this.$onInit = () => {
      self.renderReactComponent().then(() => {
        self.unregisterWatcher = $scope.$watchGroup(
          [
            '$bulkNameChangeModalCtrl.open',
            '$bulkNameChangeModalCtrl.selectedIds',
          ],
          ([_open, _selectedIds]) => {
            self.renderReactComponent();
          }
        );
      });
    };

    this.$onDestroy = () => {
      if (self.unregisterWatcher) {
        self.unregisterWatcher();
      }
    };

    $rootScope.$on('bulkEditBroadcast', (event, args) => {
      if (args.tableId === self.targetTableId && args.id === "name_change") {
        // copy the selected id array to guard against us accidentally clobbering it in a way that would break the AngularJS side
        self.selectedIds = Array.isArray(args.selectedIds) ? args.selectedIds.slice() : [];
        self.open = true;
      }
    });
  }]
});
